import { render, staticRenderFns } from "./UserUsageTraineeExamDialog.vue?vue&type=template&id=78a8656e&"
import script from "./UserUsageTraineeExamDialog.vue?vue&type=script&lang=ts&"
export * from "./UserUsageTraineeExamDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports